import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LinesPaginationWithCount } from '../../../../data/models/lines-pagination-with-count';
import { AccountService } from '../../../../services/account.service';
import { AppService } from '../../../../services/app.service';
import { authenticationEnum, authorizationEnum } from '../menu-sidebar/menu-sidebar.component';
import { isNullOrUndefined } from 'is-what';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleMenuSidebar: EventEmitter<any> = new EventEmitter<any>();

  user: any = null;
  accountName: string;
  lines: any[];
  public ImgUrl = ' ';

  constructor(private appService: AppService, private router: Router, private accountService: AccountService) { }

  ngOnInit() {
    sessionStorage.removeItem(authorizationEnum.showReachabilityDetails);
    this.toggleMenuSidebar.emit();
    this.accountService.getAccountName().subscribe((res:any) => {
      if (res) {
        this.accountName = res.name;
        
        sessionStorage.setItem(authorizationEnum.showReachabilityDetails, res.showReachabilityDetails);
      }
    })
    if (sessionStorage.getItem(authenticationEnum.username))
      this.user = sessionStorage.getItem(authenticationEnum.username);

    let cutomerLogoImage = sessionStorage.getItem(authenticationEnum.logoImage);
    if (cutomerLogoImage) {
      this.ImgUrl = 'data:image/png;base64,' + cutomerLogoImage;
    }


  }

  onLineChange(event) {
    this.loadLines(event.query);
  }
  onLineSelect($event) {
    this.router.navigate(['linedetails/', $event.id /*lineId*/]);
    //<a class="nav-link"[routerLink] = "item.link" >
  }

  loadLines(filter) {
    
    let obj = {
      skipped: 0,
      size: 10,
      filter: filter
    }
    this.accountService.getLinesDetailsOfAccountPagination(obj).subscribe((res: LinesPaginationWithCount) => {
      if (res) {
        res.lines.forEach(l => {
          l.fakeName = l.name.split('.')[0] + "." + l.quoteID + " (" +
            ((!isNullOrUndefined(l.popName) && l.popName !== "NULL") ? l.popName : (!isNullOrUndefined(l.popConvention) && l.popConvention!=="NULL") ? l.popConvention : "") + ")";
          if (l.pairNum)
            l.fakeName += (".Pair" + l.pairNum);
        });
        this.lines = res.lines;
       

      }
      else {
        this.lines = [];
       
      }
    }, (error) => {
      //this.messageService.add({ severity: 'error', summary: 'Get Lines Details', detail: 'Could not retrieve Lines of this account, please refresh the page' });
      
    })

  }




  logout() {
    this.appService.logout();
  }
}
